// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-button {
  border: 1px solid #e9e9e9;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.nav-button__arrow {
  display: grid;
  place-items: center;
}`, "",{"version":3,"sources":["webpack://./src/common/nav-button/nav-button.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;AACR","sourcesContent":[".nav-button {\n    border: 1px solid #e9e9e9;\n    height: 40px;\n    width: 40px;\n    border-radius: 8px;\n    background: white;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n\n    &__arrow {\n        display: grid;\n        place-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
